var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeed = function SvgSpeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 12.73a2.727 2.727 0 1 0 0 5.455 2.727 2.727 0 0 0 0-5.455m0 3.637a.909.909 0 1 1 0-1.818.909.909 0 0 1 0 1.818m0-7.273a6.42 6.42 0 0 0-4.5 1.864.91.91 0 0 0 0 1.281.91.91 0 0 0 1.282 0 4.546 4.546 0 0 1 6.436 0 .9.9 0 0 0 .637.273.91.91 0 0 0 .69-1.554A6.42 6.42 0 0 0 10 9.094m0-3.636a10.07 10.07 0 0 0-7.073 2.927.913.913 0 1 0 1.291 1.29 8.18 8.18 0 0 1 11.564 0 .9.9 0 0 0 .645.264.91.91 0 0 0 .646-1.554A10.07 10.07 0 0 0 10 5.458m9.646.354a13.636 13.636 0 0 0-19.291 0 .913.913 0 0 0 1.29 1.291 11.82 11.82 0 0 1 16.71 0 .91.91 0 0 0 1.29 0 .91.91 0 0 0 0-1.29"
  })));
};
export default SvgSpeed;